import styled from 'styled-components';

export const FormSection = styled.div`
  margin-bottom: 56px;
`;

export interface ButtonWrapperProps {
  continueButtonClicked: boolean;
}

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  text-align: right;

  & > button:first-child {
    padding: ${({ continueButtonClicked }) => continueButtonClicked && '14px 32px'};
  }
`;

export const TextSpacer = styled.div`
  margin-top: 16px;
`;

export const BodySpacer = styled.div`
  margin-top: 24px;
`;
